import React from 'react';
import { useTranslate } from 'react-admin';
import { ResourceFormDialog } from '@/components/common';
import CostCenterForm from './CostCenterForm';
import { createEmptyCostCenterFormValues } from '../constants';

export interface CostCenterFormDialogProps {
  open: boolean;
  onClose: () => void;
  recordId: string | number | null;
}

export const CostCenterFormDialog: React.FC<CostCenterFormDialogProps> = ({
  open,
  onClose,
  recordId,
}) => {
  const translate = useTranslate();
  const isEdit = recordId !== null;
  return (
    <ResourceFormDialog
      open={open}
      onClose={onClose}
      mode={isEdit ? 'edit' : 'create'}
      resource="credit-consumption/cost-center"
      recordId={recordId ?? undefined}
      title={translate('resources.credit-consumption/cost-center.dialog.title')}
      createRecord={!isEdit ? createEmptyCostCenterFormValues() : undefined}
      createdMessage="resources.credit-consumption/cost-center.notifications.created"
      updatedMessage="resources.credit-consumption/cost-center.notifications.updated"
      maxWidth="md"
    >
      <CostCenterForm />
    </ResourceFormDialog>
  );
};

export default CostCenterFormDialog;
